import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import TableInstalacionesComponent from '../../components/UsuarioInspectorEnCampo/Asociados/TableInstalacionesComponent';

function PanelAsociados(props) {
    return (
        <Fragment><br />
            <div className='container'>
                <Fragment>
                    <div className='row mt-3'>
                        <div className='col-xs-12 '>
                            <p className='mt-1' style={{ fontSize: '25px' }}>Panel de Clientes:</p>
                        </div>
                    </div>
                    
                    <TableInstalacionesComponent></TableInstalacionesComponent>
                </Fragment>
            </div>

        </Fragment>
    );
};


export default withRouter(PanelAsociados)
